import React, { FunctionComponent } from "react";
import FulfillmentTeamItems from "./FulfillmentTeamItems";
import { StoreType } from "../../redux/store";
import { connect } from "react-redux";
import Login from "./Login";

type RootProps = { logged: boolean | null };
const Root: FunctionComponent<RootProps> = ({ logged }: RootProps) => {
  if (logged) return <FulfillmentTeamItems />;
  return <Login />;
};

const mapStateToProps = ({ auth: { logged } }: StoreType) => ({
  logged,
});

export default connect(mapStateToProps)(Root);
